var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPickupPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9975 6.38024L11 11.0094L19.0025 6.38024M11 20.2402V11.0002M19.25 14.6669V7.33357C19.2497 7.01207 19.1648 6.69631 19.0039 6.41797C18.843 6.13962 18.6118 5.90849 18.3333 5.74774L11.9167 2.08107C11.638 1.92016 11.3218 1.83545 11 1.83545C10.6782 1.83545 10.362 1.92016 10.0833 2.08107L3.66667 5.74774C3.38824 5.90849 3.15698 6.13962 2.99609 6.41797C2.8352 6.69631 2.75033 7.01207 2.75 7.33357V14.6669C2.75033 14.9884 2.8352 15.3042 2.99609 15.5825C3.15698 15.8608 3.38824 16.092 3.66667 16.2527L10.0833 19.9194C10.362 20.0803 10.6782 20.165 11 20.165C11.3218 20.165 11.638 20.0803 11.9167 19.9194L18.3333 16.2527C18.6118 16.092 18.843 15.8608 19.0039 15.5825C19.1648 15.3042 19.2497 14.9884 19.25 14.6669Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPickupPoint);
export default __webpack_public_path__ + "static/media/icon-pickup-point.dafd2804c35cd742564fb5b919a8af7d.svg";
export { ForwardRef as ReactComponent };